import { useCallback, useRef, useState } from "react";

const useTinymce = () => {
  // 文本内容
  const [richValue, setRichValue] = useState('');
  const descriptionRef=useRef<any>(null);
  const [uploadImageVisible, setUploadImageVisible] =useState(false);//图片上传弹窗
  const [imagesFiles, setImagesFiles] = useState<any[]>([]);//图片文件
  const totalImageSize = Math.round(imagesFiles.reduce((pre,cur:any)=>pre+cur.size,0)/1024);

  const onDesChange=useCallback(
    (value:any) => {
      setRichValue(value)
  },[])
  
  const onUploadImageCancel=useCallback(()=>{
    setUploadImageVisible(false);
  },[])

  const uploadImage = useCallback(() => {
    console.log("uploadImage");
    setUploadImageVisible(true);
  },[])

  const addUploadImageButton=useCallback(()=>{
    if(descriptionRef.current==null) return;
    descriptionRef.current.addToolBarPlugin('uploadImage',{
      icon:'image',
      tooltip:'插入图片',
      onAction:uploadImage
    });
  },[])
  /**
   * 插入图片
   */
  const insertImage=useCallback((files:any[])=>{
    console.log("insertImage",files);
    setImagesFiles(pre=>[...pre,...files]);
    files.forEach((file:any)=>{
      descriptionRef.current.insertContent(`<img  src="${file.url}" />`);
    })
  },[])
  return {
    richValue,
    descriptionRef,
    uploadImageVisible,
    totalImageSize,
    setRichValue,
    onDesChange,
    onUploadImageCancel,
    addUploadImageButton,
    insertImage
  }
}

export default useTinymce;